/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */
import createLogger from 'ion-logger';
import ValidTopics, { TopicsList } from './topics';
import Constants from '../lib/constants';

const logger = createLogger('ion:broker:validation');

function validateTopics(topic: string): boolean {
  let branch = ValidTopics;
  return topic.split(Constants.CHILD_SEPARATOR).every((name, index, arr) => {
    if (branch == null && index !== arr.length - 1) {
      return false;
    }

    if (typeof branch === 'string') {
      // Regexp pattern to match
      try {
        const re = new RegExp(branch);
        return re.test(name);
      } catch (e) {
        logger.error('An error occurred while compiling regexp:', e);
        return false;
      }
    }

    if (typeof branch === 'object') {
      if (!(name in branch)) {
        return false;
      }

      // If name is there, reset branch to point to the sub-branch
      branch = branch[name] as TopicsList;
      return true;
    }

    // If we're here, something weird has happened, so just message an error
    // and then return false
    logger.log('branch had an unexpected type:', typeof branch);
    return false;
  });
}

export default validateTopics;
